:host {
  --cms-default-grid-area: auto / auto / auto / span 12;
  --cms-default-grid-area-content: auto / auto / auto / span 12;
  @include cms-base-font-100;
  margin: 0 auto var(--cms-components-mb);
  padding: 0 var(--cms-spacing-100);
  box-sizing: content-box;
  display: var(--cms-container-display);
  gap: var(--cms-grid-gap);
  height: var(--cms-grid-row-height);
  max-width: calc(var(--cms-container-max-width) - var(--cms-spacing-200));
  grid-template-columns: var(--cms-grid-template-columns);
}

:host([layout="two-thirds"]) {
  --cms-default-grid-area: auto / auto / auto / span 12;
}

@include media-width($breakpoint-sm) {
  :host([layout="two-thirds"]) {
    --cms-default-grid-area: auto / 3 / auto / span 8;
  }
}

:host([picture-position="top"]),
:host([picturePosition="top"]) {
  .text-wrapper {
    --cms-default-grid-area-content: 2 / auto / auto / span 12;
  }

  .picture-wrapper {
    --cms-default-grid-area-content: 1 / auto / auto / span 12;
  }
}

.container {
  grid-area: var(--cms-default-grid-area);
  --cms-grid-padding: 0;
  color: var(--cms-theme-text-color);
  @include cms-default-grid-container;
  width: 100%;
}

.picture-wrapper {
  grid-area: var(--cms-default-grid-area-content);

  img {
    max-width: 100%;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    padding-bottom: var(--cms-spacing-075);
  }

  .picture-description {
    font-style: italic;
    margin-bottom: var(--cms-spacing-075);
  }
}

.text-wrapper {
  grid-area: var(--cms-default-grid-area-content);

  p {
    margin-bottom: var(--cms-spacing-075);
    margin-top: 0;
    padding: 0;
  }

  a {
    text-decoration: underline;
    background-color: transparent;
    color: var(--cms-theme-text-color);
  }

  .template-highlight {
    text-align: center;
    font-weight: var(--cms-base-font-weight-700);
    margin: var(--cms-spacing-075);
    padding-top: 0;
    padding-bottom: 0;
    padding-left: var(--cms-spacing-050);
    padding-right: var(--cms-spacing-050);
    font-size: var(--cms-font-size-112);
    line-height: var(--cms-line-height-111);
  }
}

@include media-width($breakpoint-sm) {
  .template-highlight-full {
    flex: 0 0 66.6666666667%;
    max-width: 66.6666666667%;
  }

  :host([picture-position="right"]),
  :host([picturePosition="right"]) {
    .text-wrapper {
      --cms-default-grid-area-content: auto / auto / auto / span 8;
    }

    .picture-wrapper {
      --cms-default-grid-area-content: auto / auto / auto / span 4;
    }
  }
}